export default "/img/IN.b9d21c8fdd97032e234a7290d4871345.png";